var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("耗材领用单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.stuffAppturnVoucher, rules: _vm.voucherRulesInfo }
        },
        [
          _c("div", { staticClass: "simple-form flex col-2" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("领用日期")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "theDate" } },
                    [
                      _c("el-date-picker", {
                        attrs: { type: "date", placeholder: "选择日期" },
                        model: {
                          value: _vm.stuffAppturnVoucher.theDate,
                          callback: function($$v) {
                            _vm.$set(_vm.stuffAppturnVoucher, "theDate", $$v)
                          },
                          expression: "stuffAppturnVoucher.theDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("领用仓库")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "warehouseId" } },
                    [
                      _c(
                        "el-select",
                        {
                          on: {
                            change: function($event) {
                              _vm.warehouseChange()
                            }
                          },
                          model: {
                            value: _vm.stuffAppturnVoucher.warehouseId,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.stuffAppturnVoucher,
                                "warehouseId",
                                $$v
                              )
                            },
                            expression: "stuffAppturnVoucher.warehouseId"
                          }
                        },
                        _vm._l(_vm.warehouseList, function(item) {
                          return _c("el-option", {
                            attrs: { label: item.name, value: item.id }
                          })
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  { staticClass: "inline-block mr10" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.audtoApplyState,
                              callback: function($$v) {
                                _vm.audtoApplyState = $$v
                              },
                              expression: "audtoApplyState"
                            }
                          },
                          [_vm._v("自动申请")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.audtoApplyState
                  ? _c(
                      "div",
                      { staticClass: "inline-block mr10" },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.autoAuditPass,
                                  callback: function($$v) {
                                    _vm.autoAuditPass = $$v
                                  },
                                  expression: "autoAuditPass"
                                }
                              },
                              [_vm._v("自动审核")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", disabled: _vm.advancedData != null },
                on: {
                  click: function($event) {
                    _vm.showDeviceListDlg()
                  }
                }
              },
              [_vm._v("通用选择")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small ml10",
                class: { hidden: _vm.advancedData == null },
                on: {
                  click: function($event) {
                    _vm.setStaff()
                  }
                }
              },
              [_c("span", [_vm._v("设置领用人")])]
            ),
            _vm._v(" "),
            _vm.voucherId == null &&
            _vm.stuffAppturnVoucher.stuffItemList != null &&
            _vm.stuffAppturnVoucher.stuffItemList.length > 0
              ? _c(
                  "button",
                  {
                    staticClass: "swb-btn swb-btn-small",
                    on: { click: _vm.setStaff }
                  },
                  [_c("span", [_vm._v("设置领用人")])]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.advancedData != null
        ? _c(
            "div",
            [
              _c("div", { staticClass: "simple-form" }, [
                _c("div", { staticClass: "form-group center" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.stuffAppturnVoucher.departName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.stuffAppturnVoucher.staffName))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("swb-asset-advanced-view", {
                attrs: {
                  advancedData: _vm.advancedData,
                  clearAdvanced: _vm.clearAdvanced
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.advancedData == null
        ? _c(
            "div",
            [
              _c("div", { staticClass: "simple-row" }, [
                _c("div", { staticClass: "right" }, [
                  _vm.stuffAppturnVoucher.stuffItemList != null
                    ? _c("span", [
                        _vm._v(
                          "已选择(" +
                            _vm._s(
                              _vm.stuffAppturnVoucher.stuffItemList.length
                            ) +
                            ")"
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "stuffitemInfo",
                  attrs: { model: _vm.stuffAppturnVoucher }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-layout",
                      staticStyle: { width: "100%", "overflow-x": "auto" }
                    },
                    [
                      _c("table", { staticClass: "custom-tbl error-prompt" }, [
                        _c("thead", { staticClass: "head" }, [
                          _c("tr", { staticClass: "row" }, [
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("耗材描述全称")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("耗材名称")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "200" }
                              },
                              [_vm._v("型号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "200" }
                              },
                              [_vm._v("规格")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("分类")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("分类分组")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "150" }
                              },
                              [_vm._v("品牌")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "140" }
                              },
                              [_vm._v("责任部门")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "140" }
                              },
                              [_vm._v("责任人")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "required",
                                attrs: { width: "130" }
                              },
                              [_vm._v("领用部门")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "required",
                                attrs: { width: "100" }
                              },
                              [_vm._v("领用人")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "160" }
                              },
                              [_vm._v("批次号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("可用数量")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("领用数量")]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "80" } }, [
                              _vm._v("单位")
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("备注")]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "150" } }, [
                              _vm._v("操作")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          { staticClass: "body" },
                          _vm._l(
                            _vm.stuffAppturnVoucher.stuffItemList,
                            function(stuffItemInfo, index) {
                              return _c("tr", { staticClass: "row" }, [
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v(_vm._s(stuffItemInfo.title))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v(_vm._s(stuffItemInfo.stuffName))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v(_vm._s(stuffItemInfo.model || ""))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _vm._v(
                                      _vm._s(stuffItemInfo.fixedSpec || "")
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v(_vm._s(stuffItemInfo.catName))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getGoodsCatDevcGroupName(
                                          stuffItemInfo.catId
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v(_vm._s(stuffItemInfo.brandName))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _vm._v(
                                      _vm._s(stuffItemInfo.principalDepartName)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v(_vm._s(stuffItemInfo.principalName))]
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(stuffItemInfo.departName))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(stuffItemInfo.staffName))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v(_vm._s(stuffItemInfo.batchNo))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "right" } },
                                  [_vm._v(_vm._s(stuffItemInfo.curAvQuantity))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          props:
                                            "stuffItemInfoList." +
                                            index +
                                            ".quantity",
                                          rules: {
                                            validator: _vm.quantityChange,
                                            trigger: "blur"
                                          }
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "text-right",
                                          attrs: { type: "number" },
                                          on: {
                                            change: function($event) {
                                              _vm.changeQuantity(stuffItemInfo)
                                            }
                                          },
                                          model: {
                                            value: stuffItemInfo.quantity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                stuffItemInfo,
                                                "quantity",
                                                $$v
                                              )
                                            },
                                            expression: "stuffItemInfo.quantity"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(stuffItemInfo.theUnit))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "textarea-value",
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: stuffItemInfo.memo,
                                        callback: function($$v) {
                                          _vm.$set(stuffItemInfo, "memo", $$v)
                                        },
                                        expression: "stuffItemInfo.memo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "swb-btn-link",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteStuffInfo(index)
                                          }
                                        }
                                      },
                                      [_vm._v("移除")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "swb-btn-link",
                                        on: {
                                          click: function($event) {
                                            _vm.setStaffInfo(index)
                                          }
                                        }
                                      },
                                      [_vm._v("设置领用人")]
                                    )
                                  ]
                                )
                              ])
                            }
                          )
                        ),
                        _vm._v(" "),
                        _c("tfoot", { staticClass: "foot" }, [
                          _vm.stuffAppturnVoucher.stuffItemList == null ||
                          _vm.stuffAppturnVoucher.stuffItemList.length == 0
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "line-height": "40px"
                                    },
                                    attrs: { colspan: "16" }
                                  },
                                  [
                                    _c("span", { staticClass: "font-gray3" }, [
                                      _vm._v("暂无数据")
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary mr10",
            on: { click: _vm.prevStock }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: { click: _vm.saveAppturnVoucher }
          },
          [_vm._v("保存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("领用信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("耗材信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("领用部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("领用人")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3cece5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3cece5e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shopStuff/StuffAppturnVoucherSave.vue
// module id = 3025
// module chunks = 0